import SocialImg from './SocialImg';
import SocialWrapper from './SocialWrapper';

export { SocialImg, SocialWrapper };
